import { render, staticRenderFns } from "./OrganizationDisplayName.vue?vue&type=template&id=5abe4c46&scoped=true&"
import script from "./OrganizationDisplayName.vue?vue&type=script&lang=js&"
export * from "./OrganizationDisplayName.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDisplayName.vue?vue&type=style&index=0&id=5abe4c46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe4c46",
  null
  
)

export default component.exports